import React, { useCallback, useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
// import { Line } from 'react-chartjs-2';
import Select from 'react-select';
import dataExcel from '../../jsons/imacec-vs-aprob.json';
// import exportFromJSON from 'export-from-json';
// import jsonColor from "../../jsons/colores.json"
import LineChart from '../../Components/highChart/dobleje/DualAxesIM'
// import { getOptions } from 'highcharts';
import {listaColoresChart} from '../../Components/shared/colores';

type listItemT = {
  label: string,
  value: string
}

const defaultData = {
  label: '',
  data: [],
  borderColor: '',
  fill: false,
  tension: 0.4,
};

const ChartV5: React.FC = (props: any) => {
  const [data, setData]= useState<any>([]);
  const [label, setLabel]=useState<any>([]);

  useEffect(() => {
    const response = dataExcel.Hoja1.map((element, i)=>{
      //console.log(Object.values(element.datos[0]).map(value=>Number(value)));
      
        // @ts-ignore
        element.animation = { duration: 4000, easing: 'easeOutBounce'}
      
      element.data = Object.values(element.datos[0]).map(value=>Number(value))
      return element
    })

    console.log(response)
    setLabel(Object.keys(dataExcel.Hoja1[0].datos[0]))
    setData(response)
    
  }, [])
  
  return (
    <div className="shadow p-3 mb-5 bg-body rounded chart-content">
      {/* <Select
        isMulti
        styles={customStyles}
        placeholder="Seleccionar..."
        closeMenuOnSelect={true}
        options={getItemsToAddList()}
        onChange={onChangeSelect}
      /> */}
      <div className='mt-3'>
        
       <LineChart
            allData={data}
            labels={label} 
            
        /> 
      </div>
    </div>
  )
}

export default ChartV5;